import { render, staticRenderFns } from "./Allot.vue?vue&type=template&id=60be740e&"
import script from "./Allot.vue?vue&type=script&lang=js&"
export * from "./Allot.vue?vue&type=script&lang=js&"
import style0 from "./Allot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports